export default __webpack_public_path__ + "static/media/Bracers of the First Circle.98ce96fc.jpg";